import helpers from './helpers';

export default (function () {
  return {
    init() {
      this.accordion();
    },

    accordion() {
      const accordionBtn = [...document.querySelectorAll('.js-accordion-btn')];

      helpers.forEach(accordionBtn, (i, elem) => {
        elem.addEventListener('click', (e) => {
          const parent = e.target.closest('.js-accordion-list');
		  const accordionID = elem.getAttribute('aria-controls');
		  const accordionContent = parent.querySelector(`#${accordionID}`);
		  const contentHidden = accordionContent.getAttribute('aria-hidden') === 'true' ? 'false' : 'true';
		  const buttonExpanded = e.target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';

		  e.target.setAttribute('aria-expanded', buttonExpanded);
		  e.target.classList.toggle('btn--icon-plus--white');
		  e.target.classList.toggle('btn--icon-minus--white');
		  accordionContent.setAttribute('aria-hidden', contentHidden);
        });
      });
    },
  };
})();
